import React from 'react'
import { ScreenContainer } from './App'

export const How = () => {
  return (
    <>
      <ScreenContainer title="Why Talking-Iris Is a Game-Changer in Eye-Tracking AAC" bgColor="bg-blue-400">
        <div className="bg-gray-100 text-gray-800">
          <main className="max-w-5xl mx-auto p-6 space-y-8">
            {/* Problem Section */}
            <section className="bg-white rounded-lg shadow-md p-6">
              <h2 className="text-2xl font-bold text-blue-500 mb-4">The Problem with Eye-Tracking AACs</h2>
              <p className="text-lg leading-relaxed">
                Current eye-tracking AAC devices are notoriously complex and cost upwards of $6,000. They often require insurance approval and months of paperwork—leaving stroke survivors, ALS patients, and individuals with locked-in syndrome or cerebral palsy waiting in silence. Even after setup, these devices overwhelm users with cluttered interfaces and steep learning curves.
              </p>
            </section>

            {/* Talking-Iris Solution */}
            <section className="bg-white rounded-lg shadow-md p-6">
              <h2 className="text-2xl font-bold text-blue-500 mb-4">How Talking-Iris Changes Everything</h2>
              <p className="text-lg leading-relaxed">
                Talking-Iris is a purpose-built, affordable AAC system powered by real-time eye-tracking. Designed to work out of the box, it requires no insurance maze, therapist onboarding, or tech expertise. Just look, and speak.
              </p>
              <p className="text-lg leading-relaxed">
                Whether your loved one is bedridden or facing loss of speech due to neurological conditions, Talking-Iris provides a clear, fast, and direct way to communicate.
              </p>
            </section>

            {/* Simplicity and Speed */}
            <section className="bg-white rounded-lg shadow-md p-6">
              <h2 className="text-2xl font-bold text-blue-500 mb-4">Simplicity that Restores Dignity</h2>
              <p className="text-lg leading-relaxed">
                Unlike traditional systems with overwhelming folder trees and tiny icons, Talking-Iris features large, high-contrast tiles that respond to gaze. No tapping, no swiping—just natural eye movement. Built-in phrase banks allow for rapid communication of basic needs, emotions, and thoughts.
              </p>
            </section>

            {/* Emotional Impact */}
            <section className="bg-white rounded-lg shadow-md p-6">
              <h2 className="text-2xl font-bold text-blue-500 mb-4">More Than a Device—A Voice Restored</h2>
              <p className="text-lg leading-relaxed">
                Your loved one is still here. Still thinking. Still feeling. Talking-Iris gives them their voice back—without delay, without complexity. It’s not just communication. It’s connection.
              </p>
            </section>

            {/* Cost Advantage */}
            <section className="bg-white rounded-lg shadow-md p-6">
              <h2 className="text-2xl font-bold text-blue-500 mb-4">Built to Be Accessible</h2>
              <p className="text-lg leading-relaxed">
                Most AAC eye-tracking devices are priced out of reach. Talking-Iris is affordable without compromise. By removing the insurance gatekeeping and technical hurdles, we’ve made communication possible for every family.
              </p>
            </section>
          </main>

          <footer className="bg-blue-500 text-white p-4 text-center">
            <p className="text-lg">Their mind is still sharp. Now their voice is too. | <strong>Talking-Iris</strong></p>
          </footer>
        </div>
      </ScreenContainer>
    </>
  )
} 
